import { styled } from '@mui/material/styles';

export const StyledName = styled('div')(({ theme }) => ({
  cursor: 'pointer',
  
  '&:hover': {
    color: theme.palette.primary.main
  }
}));
